import { GA4_MEASUREMENT_ID } from '../configs';

export function getGASessionId() {
  const pattern = new RegExp(`${GA4_MEASUREMENT_ID}=GS\\d*\\.\\d*\\.(\\d+)`);
  const match = document.cookie.match(pattern);

  return match ? match[1] : null;
}
